import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CultureTreeSelect from '@client/components/ui/select/CultureTreeSelect';

const CultureStepContent = ({
  step,
  value,
  selectionLabels,
  onChange,
  onForceRevalidation,
  mode,
}) => {
  const { t } = useTranslation('treatment-search');

  const handleChange = (selectedValues, selectedNodes) => {
    const values = Array.isArray(selectedValues) ? selectedValues : [];
    const nodes = Array.isArray(selectedNodes) ? selectedNodes : [];

    const transformedItems = nodes.filter(Boolean).map((node) => ({
      value: node.value || node.id,
      label: node.label || node.french_name || node.name || String(node.value || node.id),
    }));

    onChange(values, transformedItems);
  };

  // Use different culture filter based on mode:
  // - extraction mode: show_in_customer_filter_excel
  // - normal multichoix: show_in_customer_filter_pdf
  const filterParams = useMemo(() => (
    mode === 'extraction'
      ? { show_in_customer_filter_excel: true }
      : { show_in_customer_filter_pdf: true }
  ), [mode]);

  return (
    <div className="w-full">
      <CultureTreeSelect
        labelField="french_name"
        isMulti={true}
        label={t(step.placeholder)}
        placeholder={t(step.placeholder)}
        value={value}
        onChange={handleChange}
        checkStrictly={false}
        treeCheckable={true}
        showCheckedStrategy="SHOW_CHILD"
        languageFields={step?.languageConfig?.fields}
        languageLabels={step?.languageConfig?.labels}
        defaultLanguage={step?.languageConfig?.defaultLanguage || 'fr'}
        showLanguageSelector={!!step?.languageConfig}
        onLanguageChange={onForceRevalidation}
        filterParams={filterParams}
        style={{ width: '100%' }}
      />
    </div>
  );
};

export default CultureStepContent;
